import TimelineItem from "@/components/pages/MicroSite/Templates/SitecraftTemplate/Mission/TimelineItem"
import type { MicroSite } from "@/lib/api";

const MissionTimeline = ({data}:{data: MicroSite}) => {
if(!data){
    return null;
  };  

  return (
    <div className="flex relative flex-col w-full p-4 lg:p-8 gap-6  justify-center" >
      <div className="grid gap-4 lg:gap-12 w-full px-4 lg:px-4">
      {Array.isArray(data?.missionTimeLineSection?.missionTimeLineSectionDetails) && data.missionTimeLineSection.missionTimeLineSectionDetails.map((item, index) => (
    
        <TimelineItem key={index} data={item} brandingData={data?.branding}  />
      ))}
    </div>
    </div>
    
  )
}

export default MissionTimeline